import { render, staticRenderFns } from "./stayState.vue?vue&type=template&id=08f5506b"
import script from "./stayState.vue?vue&type=script&lang=js"
export * from "./stayState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports